import React from 'react';
import { motion } from 'framer-motion';
import { Check, Plus, ArrowRight } from 'lucide-react';
export function ServicesSection() {
  return <section className="py-24 bg-white" id="planes" data-id="element-342">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-343">
        <div className="text-center mb-16" data-id="element-344">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-primary mb-6" data-id="element-345">
            Elige tu punto de partida.
          </motion.h2>
          <p className="text-xl text-gray-600 font-light mb-8" data-id="element-346">
            No hay un camino único. Hay el camino correcto para ti.
          </p>
          <div className="w-24 h-1 bg-inkova-accent mx-auto rounded-full" data-id="element-347"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-20 rounded-2xl overflow-hidden shadow-lg max-w-5xl mx-auto" data-id="element-348">
          <img src="https://cdn.magicpatterns.com/uploads/rojTV54FnSaLdwaFZYfqdJ/ChatGPT_Image_Apr_1,_2026,_05_00_05_PM.png" alt="Consultoría de negocios en Inkova" className="w-full h-64 md:h-96 object-cover" data-id="element-349" />
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 mb-20" data-id="element-350">
          {/* Plan 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-inkova-light rounded-3xl p-8 border border-inkova-accent/20 flex flex-col h-full" data-id="element-351">
            <div className="mb-6" data-id="element-352">
              <h3 className="text-xl font-serif font-bold text-inkova-primary mb-2 uppercase tracking-wider" data-id="element-353">
                PLAN 1
              </h3>
              <h4 className="text-2xl font-bold text-inkova-dark mb-4" data-id="element-354">
                Fundación Empresarial
              </h4>
              <div className="text-4xl font-bold text-inkova-primary mb-4" data-id="element-355">
                $590
              </div>
              <p className="text-sm text-gray-600 italic" data-id="element-356">
                Para el emprendedor que quiere crear su empresa correctamente y
                tener la base para operar desde el día uno.
              </p>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-357">
              <div data-id="element-358">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-359">
                  Registro y documentación:
                </h5>
                <ul className="space-y-2" data-id="element-360">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-361">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-362" />
                    Registro LLC en Florida
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-363">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-364" />
                    Obtención de EIN
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-365">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-366" />
                    Presentación ante Sunbiz
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-367">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-368" />
                    Confirmación oficial de documentos
                  </li>
                </ul>
              </div>

              <div data-id="element-369">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-370">
                  Estructura y acompañamiento:
                </h5>
                <ul className="space-y-2" data-id="element-371">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-372">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-373" />
                    Sesión estratégica de claridad
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-374">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-375" />
                    Definición básica del modelo de negocio
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-376">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-377" />
                    Guía de organización inicial
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-378">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-379" />
                    Asesoría para apertura de cuenta bancaria
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-380">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-381" />
                    Paso a paso de cumplimiento inicial
                  </li>
                </ul>
              </div>

              <div data-id="element-382">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-383">
                  Lo que te entregamos:
                </h5>
                <ul className="space-y-2" data-id="element-384">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-385">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-386" />
                    Checklist completo del proceso
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-387">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-388" />
                    Documentación requerida
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-389">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-390" />
                    Guía: qué hacer después de crear la empresa
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-391">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-392" />
                    Responsabilidades anuales explicadas
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-inkova-accent/20" data-id="element-393">
              <p className="text-xs text-gray-500 mb-4" data-id="element-394">
                Registered Agent no incluido. Inkova gestiona y coordina el
                proceso de registro. No somos un despacho de abogados.
              </p>
              <div className="bg-white p-4 rounded-xl text-sm font-medium text-inkova-dark text-center shadow-sm mb-4" data-id="element-395">
                No es solo crear una empresa. Es empezar con estructura.
              </div>
              <a href="https://inkovacreation.store/shop/7f390a19-9be8-4bef-be02-00a79bcf09f8" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-inkova-primary text-white font-bold py-3 rounded-xl hover:bg-inkova-dark transition-colors" data-id="element-396">
                Quiero este plan
              </a>
            </div>
          </motion.div>

          {/* Plan 3 - Highlighted */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-inkova-primary text-white rounded-3xl p-8 shadow-2xl relative transform lg:-translate-y-4 flex flex-col h-full border-2 border-inkova-accent" data-id="element-397">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-inkova-accent text-inkova-primary font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wider shadow-lg" data-id="element-398">
              Recomendado
            </div>

            <div className="mb-6 mt-4" data-id="element-399">
              <h3 className="text-xl font-serif font-bold text-inkova-accent mb-2 uppercase tracking-wider" data-id="element-400">
                PLAN 3
              </h3>
              <h4 className="text-2xl font-bold text-white mb-4" data-id="element-401">
                Inkova Full Creation ⭐
              </h4>
              <div className="text-4xl font-bold text-white mb-4" data-id="element-402">$1,490</div>
              <p className="text-sm text-gray-300 italic" data-id="element-403">
                La solución completa para el emprendedor que quiere salir listo,
                no en proceso.
              </p>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-404">
              <div data-id="element-405">
                <h5 className="font-bold text-inkova-accent mb-3" data-id="element-406">
                  Lo que incluye:
                </h5>
                <ul className="space-y-4" data-id="element-407">
                  <li className="flex items-start text-sm text-gray-200" data-id="element-408">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-409" />
                    <span data-id="element-410">
                      <strong data-id="element-411">Todo el Plan 1</strong>
                      <br data-id="element-412" />
                      (empresa registrada y en orden)
                    </span>
                  </li>
                  <li className="flex items-start text-sm text-gray-200" data-id="element-413">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-414" />
                    <span data-id="element-415">
                      <strong data-id="element-416">Todo el Plan 2</strong>
                      <br data-id="element-417" />
                      (presencia digital lista)
                    </span>
                  </li>
                  <li className="flex items-start text-sm text-gray-200" data-id="element-418">
                    <Plus className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-419" />
                    <span data-id="element-420">
                      <strong data-id="element-421">Integración completa</strong>
                      <br data-id="element-422" />
                      entre estructura y presencia
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-white/20" data-id="element-423">
              <div className="bg-white/10 p-4 rounded-xl text-sm font-medium text-white text-center backdrop-blur-sm mb-6" data-id="element-424">
                Sales con tu negocio listo. No con una empresa en papel y una
                idea en la cabeza.
              </div>
              <a href="#reserva" className="w-full block text-center bg-inkova-accent text-inkova-primary font-bold py-4 rounded-xl hover:bg-white transition-colors text-lg" data-id="element-425">
                Este es mi plan
              </a>
            </div>
          </motion.div>

          {/* Plan 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-inkova-light rounded-3xl p-8 border border-inkova-accent/20 flex flex-col h-full" data-id="element-426">
            <div className="mb-6" data-id="element-427">
              <h3 className="text-xl font-serif font-bold text-inkova-primary mb-2 uppercase tracking-wider" data-id="element-428">
                PLAN 2
              </h3>
              <h4 className="text-2xl font-bold text-inkova-dark mb-4" data-id="element-429">
                Landing Page Estratégica
              </h4>
              <div className="text-4xl font-bold text-inkova-primary mb-4" data-id="element-430">
                $950
              </div>
              <p className="text-sm text-gray-600 italic" data-id="element-431">
                Para el emprendedor que necesita presencia digital clara,
                profesional y lista para convertir.
              </p>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-432">
              <div data-id="element-433">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-434">
                  Lo que incluye:
                </h5>
                <ul className="space-y-2" data-id="element-435">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-436">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-437" />
                    Landing page informativa (1 página)
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-438">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-439" />
                    Copy estratégico adaptado a tu servicio o producto
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-440">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-441" />
                    Estructura enfocada en conversión
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-442">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-443" />
                    Diseño alineado a tu identidad
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-444">
                    <Check className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-445" />
                    Lista para recibir clientes desde el día 1
                  </li>
                </ul>
              </div>

              <div data-id="element-446">
                <h5 className="font-bold text-inkova-dark mb-3" data-id="element-447">
                  Diseñada para:
                </h5>
                <ul className="space-y-2" data-id="element-448">
                  <li className="flex items-start text-sm text-gray-700" data-id="element-449">
                    <ArrowRight className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-450" />
                    Presentar tu negocio de forma profesional
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-451">
                    <ArrowRight className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-452" />
                    Explicar claramente lo que ofreces
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-453">
                    <ArrowRight className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-454" />
                    Generar confianza en tu cliente ideal
                  </li>
                  <li className="flex items-start text-sm text-gray-700" data-id="element-455">
                    <ArrowRight className="w-4 h-4 text-inkova-accent mr-2 mt-0.5 flex-shrink-0" data-id="element-456" />
                    Prepararte para vender
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-inkova-accent/20" data-id="element-457">
              <p className="text-xs text-gray-500 mb-4" data-id="element-458">
                Este plan incluye únicamente 1 página. Si necesitas web
                completa, tienda online o funciones adicionales → se cotiza
                según alcance.
              </p>
              <div className="bg-white p-4 rounded-xl text-sm font-medium text-inkova-dark text-center shadow-sm mb-4 italic" data-id="element-459">
                "No necesitas una web grande. Necesitas una web clara que
                convierta."
              </div>
              <a href="https://inkovacreation.store/shop/7f390a19-9be8-4bef-be02-00a79bcf09f8" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-inkova-primary text-white font-bold py-3 rounded-xl hover:bg-inkova-dark transition-colors" data-id="element-460">
                Quiero este plan
              </a>
            </div>
          </motion.div>
        </div>

        {/* Add-ons Table */}
        <div id="servicios-adicionales" className="max-w-4xl mx-auto" data-id="element-461">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-462">
            <div className="bg-inkova-light p-6 border-b border-gray-200" data-id="element-463">
              <h4 className="text-2xl font-serif font-bold text-inkova-primary text-center" data-id="element-464">
                SERVICIOS ADICIONALES
              </h4>
            </div>
            <div className="overflow-x-auto" data-id="element-465">
              <table className="w-full text-left border-collapse" data-id="element-466">
                <thead data-id="element-467">
                  <tr className="bg-gray-50 text-gray-600 text-sm uppercase tracking-wider" data-id="element-468">
                    <th className="p-4 font-medium border-b border-gray-200" data-id="element-469">
                      Servicio
                    </th>
                    <th className="p-4 font-medium border-b border-gray-200" data-id="element-470">
                      Inversión
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-800" data-id="element-471">
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-472">
                    <td className="p-4 font-medium" data-id="element-473">Annual Report (Sunbiz)</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-474">
                      $150 / año{' '}
                      <span className="text-xs text-gray-500 font-normal" data-id="element-475">
                        (fee estatal no incluido)
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-476">
                    <td className="p-4 font-medium" data-id="element-477">Operating Agreement</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-478">$150</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-479">
                    <td className="p-4 font-medium" data-id="element-480">Logo profesional</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-481">$300</td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-482">
                    <td className="p-4 font-medium" data-id="element-483">Notaría</td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-484">
                      $15 – $25
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-485">
                    <td className="p-4 font-medium" data-id="element-486">
                      Mantenimiento web trimestral
                    </td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-487">$399</td>
                  </tr>
                  <tr className="hover:bg-gray-50 transition-colors" data-id="element-488">
                    <td className="p-4 font-medium" data-id="element-489">
                      Guía Digital — Ruta USA 360
                    </td>
                    <td className="p-4 text-inkova-primary font-bold" data-id="element-490">$47</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="p-6 border-t border-gray-200 text-center" data-id="element-491">
              <a href="#reserva" className="inline-block bg-inkova-primary text-white font-bold py-3 px-8 rounded-xl hover:bg-inkova-dark transition-colors text-base" data-id="element-492">
                Solicitar este servicio
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}